import React, { useState } from 'react';
import { Container, Grid, Button, Typography, Card, CircularProgress } from '@mui/material';

import Page from '../../../components/Page';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { Select, TextField } from 'src/components';
import { useFormik } from 'formik';
import { changePasswordValidationSchema } from 'src/validations/teacher';
import '../../styles/addstudent.css';
import palette from 'src/theme/palette';
import BasicTabs from 'src/components/Tabs';
import { settingsTabs } from 'src/utils/data';
import { ToastNotifications } from 'src/components';
import { authService } from 'src/services/auth/auth.service';
import { useAuth } from 'src/context/auth/AuthContext';
export default function ChangePassword() {
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showReEnterPassword, setShowReEnterPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getBaseRoute } = useAuth();

  //   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  //   const [fileError, setFileError] = useState('');
  const [activeTab, setActiveTab] = useState(1);

  const formik = useFormik({
    initialValues: {
      newPassword: '',
      reEnterPassword: '',
    },
    validationSchema: changePasswordValidationSchema,
    onSubmit: async (values) => {
      try {
        await authService.changePassword(values.newPassword);
        //
        ToastNotifications.success('Password changed successfully');
        formik.resetForm();
      } catch (error) {
        // console.error('Error creating student:', error);
        ToastNotifications.success(error.message || 'Something went wrong');
      }
    },
  });

  console.log(formik.errors);

  return (
    <Page title="Add New Student">
      <Container maxWidth={false}>
        <BasicTabs
          value={activeTab}
          handleChange={(event, newValue) => {
            if (newValue === 0) {
              navigate(getBaseRoute('/edit-profile'));
            }
          }}
          tabs={settingsTabs}
        />
        <Card style={{ borderRadius: 16, marginTop: 30, padding: 20 }}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="New Password"
                  placeholder="Enter New Password"
                  type={showNewPassword ? 'text' : 'password'}
                  value={formik.values.newPassword}
                  onChange={formik.handleChange}
                  name="newPassword"
                  error={Boolean(formik.touched.newPassword && formik.errors.newPassword)}
                  helperText={formik.touched.newPassword && formik.errors.newPassword}
                  right={
                    <span onClick={() => setShowNewPassword(!showNewPassword)}>
                      {showNewPassword ? (
                        <FiEyeOff size={18} color={palette.grey[500]} />
                      ) : (
                        <FiEye size={18} color={palette.grey[500]} />
                      )}
                    </span>
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Re enter Password"
                  placeholder="Re enter Password"
                  type={showReEnterPassword ? 'text' : 'password'}
                  value={formik.values.reEnterPassword}
                  onChange={formik.handleChange}
                  name="reEnterPassword"
                  error={Boolean(formik.touched.reEnterPassword && formik.errors.reEnterPassword)}
                  helperText={formik.touched.reEnterPassword && formik.errors.reEnterPassword}
                  right={
                    <span onClick={() => setShowReEnterPassword(!showReEnterPassword)}>
                      {showReEnterPassword ? (
                        <FiEyeOff size={18} color={palette.grey[500]} />
                      ) : (
                        <FiEye size={18} color={palette.grey[500]} />
                      )}
                    </span>
                  }
                />
              </Grid>
            </Grid>
            <div className="_add_st_footer_row" style={{ marginTop: 15 }}>
              <Button
                variant="outlined"
                style={{ height: 48, color: 'var(--primary-main)', width: 120, margin: 5 }}
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary" style={{ height: 48, width: 120, margin: 5 }}>
                {loading ? <CircularProgress color="inherit" size={20} /> : 'Create'}
              </Button>
            </div>
          </form>
        </Card>
      </Container>
    </Page>
  );
}
